import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
import 'bootstrap/dist/css/bootstrap.min.css'
import { Container, Form, Row, Col, Button } from "react-bootstrap"
import styles from "../styles/styles.module.css"

const IndexPage = (props) => (
  <Layout>
    <SEO title="Heart Media Cares" />
    <div className={styles.mainWrapper}>
      <Img fluid={props.data.cover.childImageSharp.fluid} />
      <Container fluid>
        <Row>
          <Col lg={6}>
            <div className={styles.computer}>
              <Img fluid={props.data.computer.childImageSharp.fluid} />
            </div>
          </Col>
          <Col sm lg={6}>

            <div className={styles.hashtag}>
              <strong>#HeartMediaCares</strong>
            </div>
            <div className={styles.slogan}>
              <p>Heart Media is giving you a complimentary digital subscription to our magazines for 3 months while you are staying at home during this period. We hope to keep you engaged with the latest trends and news during this challenging time.</p>
              <p>Welcome to our world of luxury lifestyle magazines</p>
            </div>
          </Col>
        </Row>
      </Container>
      <div className={styles.goldline1}></div>
      <Img className={styles.hideOnDesktop} fluid={props.data.smallm.childImageSharp.fluid} />
      <Img className={styles.hideOnMobile} fluid={props.data.small.childImageSharp.fluid} />
      <div className={styles.goldline}></div>
      <div className={styles.formWrapper}>
        <Container>
          <Row>
            <Col>
              <h4>Sorry. This form is already closed.</h4>
              <a href="https://luxuo.com">www.LUXUO.com</a><br />
              <a href="https://mens-folio.com">www.MENS-FOLIO.com</a><br />
              <a href="https://lofficielsingapore.com">www.LOFFICIELSINGAPORE.com</a>
              <p></p>
            </Col>
            <Col lg={6}>
              <Img fluid={props.data.formside.childImageSharp.fluid} />
            </Col>

          </Row>
        </Container>

      </div>
    </div>
    <footer id="largeFooter">
      <Container fluid>
        <div className="footer-divider"></div>
        <div className="footer-row">
          <div className="footer-col footer-col-menu">
            <h4 className="footer-col-heading">Menu</h4>
            <ul className="footer-menu">
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/" rel="noopener noreferrer">About Heart Media</a></li>
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/#s-publications" rel="noopener noreferrer">Publications</a></li>
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/#s-events" rel="noopener noreferrer">Events</a></li>
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/#s-digital" rel="noopener noreferrer">Digital</a></li>
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/#s-mobile" rel="noopener noreferrer">On mobile</a></li>
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/#s-partners" rel="noopener noreferrer">Partners</a></li>
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/#s-accolades" rel="noopener noreferrer">Accolades</a></li>
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/#s-brands" rel="noopener noreferrer">Brands</a></li>
              <li className="footer-menu-item"><a target="_blank" href="https://heart-media.com/personal-data-protection.html" rel="noopener noreferrer">Personal Data Protection Act</a></li>
              <li className="footer-menu-item"><a href="https://heartmediacares.heart-media.com" rel="noopener noreferrer">#HeartMediaCares</a></li>
            </ul>
          </div>
          <div className="footer-col footer-col-contact">
            <h4 className="footer-col-heading">Contact us</h4>
            <div className="footer-contact">
              <div className="footer-contact-col footer-contact-col-1">
                <div className="contact-info">
                  <span className="contact-info-label">Singapore address: </span>
                  <span className="contact-info-value"><a href="#">137 Cecil Street, #11-01 Cecil Building, Singapore 069537</a></span>
                </div>
                <div className="contact-info">
                  <span className="contact-info-label">Malaysia address: </span>
                  <span className="contact-info-value"><a href="#"> Unit 21-09, Binjai 8 Premium Soho, No.2, Lorong Binjai, 50450 Kuala Lumpur, Malaysia</a></span>
                </div>
              </div>
              <div className="footer-contact-col footer-contact-col-2">
                <div className="contact-info">
                  <span className="contact-info-label">Email: </span>
                  <span className="contact-info-value"><a href="mailto:info@heart-media.com">info@heart-media.com</a></span>
                </div>
                <div className="contact-info">
                  <span className="contact-info-label">Office: </span>
                  <span className="contact-info-value"><a href="tel:+65 6733 9931">+65 6733 9931</a></span>
                </div>
                <div className="contact-info">
                  <span className="contact-info-label">Fax: </span>
                  <span className="contact-info-value"><a href="tel:+65 6733 5661">+65 6733 5661</a></span>
                </div>
              </div>
            </div>
            <ul className="social-icons social-icons-small">
              <li className="social-icon">
                <a target="_blank" href="//www.instagram.com/heartmediagroup/" rel="noopener noreferrer">
                  <img src={'../../social-ig-white.svg'} alt="Instagram" />
                </a>
              </li>
              <li className="social-icon">
                <a target="_blank" href="//www.linkedin.com/company/heart-media-pte-ltd/" rel="noopener noreferrer">
                  <img src={"../../social-li-white.svg"} alt="LinkedIn" />
                </a>
              </li>
              <li className="social-icon">
                <a target="_blank" href="//www.facebook.com/heartmediagroup" rel="noopener noreferrer">
                  <img src={"../../social-fb-white.svg"} alt="Facebook" />
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-col footer-col-mpas"><div>
            <div className="footer-col-heading"></div>
            <div className="mpas">
              <div className="mpas-heading">Heart Media<br />is a member of</div>
              <div className="mpas-logo"><img src={"../../icon-mpas.png"} alt="Media Publishers Association Singapore" /></div>
            </div>
          </div>
          </div>
        </div>
        <div className="footer-countries">
          <ul className="countries-row">
            <li>Singapore</li>
            <li>Kuala Lumpur</li>
            <li>Jakarta</li>
            <li>Hong Kong</li>
            <li>Shanghai</li>
          </ul>
        </div>
        <div className="footer-divider-bottom"></div>
      </Container>
    </footer>
  </Layout>
)

export default IndexPage
export const issueImage = graphql`
fragment issueImage on File {
  childImageSharp {
    fluid(maxWidth: 450) {
      ...GatsbyImageSharpFluid_tracedSVG
    }
  }
}
`;
export const fluidImage = graphql`
fragment fluidImage on File {
  childImageSharp {
    fluid(maxWidth: 1440) {
      ...GatsbyImageSharpFluid_tracedSVG
    }
  }
}
`;
export const pageQuery = graphql`
  query {
    heartmedia: file(relativePath: { eq: "heartmedia-may.png" }) {
      ...issueImage
    }
    luxinc: file(relativePath: { eq: "luxinc.png" }) {
      ...issueImage
    }
    cover: file(relativePath: { eq: "cover.jpg" }) {
      ...fluidImage
    }
    computer: file(relativePath: { eq: "computer.png" }) {
      ...fluidImage
    }
    small: file(relativePath: { eq: "small.png" }) {
      ...fluidImage
    }
    smallm: file(relativePath: { eq: "small-m.png" }) {
      ...fluidImage
    }
    formside: file(relativePath: { eq: "formside.png" }) {
      ...fluidImage
    }
  }
`;
